export default __webpack_public_path__ + "media/images/elephant_ui_working-2e653cc278c2ac871c23aeb10de1c0e2.svg";